import React from 'react';
import { Link } from 'react-router-dom';

function AppBar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/" style={{color: '#007bff'}}>Não Dito</Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link className="nav-link" to="/mensagens">Mensagens</Link>
            </li>
            <li>
            <Link className="nav-link" to="/adicionar">Adicionar</Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default AppBar;